import React from 'react';
import { Helmet } from 'react-helmet';

import { TeacherReservePageInactive as ModulesTeacherReservePageInactive } from '@edu-frontend/modules/src/pages/teacherReservePage';
import { useIntl } from 'platform-components';

import { TeacherHeader } from 'common.components/TeacherHeader/TeacherHeader';

export const TeacherReservePageInactive = () => {
    const intl = useIntl();

    return (
        <>
            <Helmet title={intl.formatMessage({ id: 'teacherReserve.pageTitle' })} />
            <TeacherHeader hideRightControls />

            <ModulesTeacherReservePageInactive
                className="teacher-reserve-page"
                description={intl.formatMessage({ id: 'teacherReserve.inactive.description' })}
                title={intl.formatMessage({ id: 'teacherReserve.inactive.title' })}
            />
        </>
    );
};
